module.exports = __webpack_public_path__ + "img/Hilltop_Grill@3x.da571bc1.webp";